import { active_project }         from 'state/store.global'
import { vis_filter, vis_detail } from 'state/store.global'
import { vis_desktop_nav }        from 'state/store.global'
import { useGet }                 from 'state/jotai'
import { Content, Root }          from './Layout.style'
import { DualMenu }               from 'components/DualMenu/DualMenu'
import { TopMenu }                from 'components/TopMenu/TopMenu'
import { useLocation }            from 'react-router-dom'
import { useBreak }               from 'hooks/useBreak'
import { useEffect, useRef, useState } from 'react'
import { Scrollbar } from 'react-scrollbars-custom'
import { isSafari } from 'react-device-detect'
import WeatherMode from 'components/SunDiagram/WeatherMode'
import { useIsIOS } from 'hooks/useIsIos'

export const Layout = ({ children }) => {
  const [viewportHeight, setViewportHeight] = useState(0);

  const here = useLocation().pathname
  const isDesktop    = useBreak('md_up')

  const { Navigation, DrawersLeft, DrawersRight, Views } = children
  
  const pin   = useGet(active_project).pin
  const left  = useGet(vis_filter)
  const right = useGet(vis_detail)
  const nav   = useGet(vis_desktop_nav)
  const activeURL = ["list", "compare", "unit", "isometry", "gallery", "downloads", "favorites"]
  const activeURLindex = activeURL.findIndex(i => here.includes(i))
  const ios = useIsIOS();
  
  const style = {
    "isometry": {
      marginTop: "72px",
      // height: isDesktop ? pin > 0 ? `calc(${viewportHeight}px - 135px)` : `calc(${viewportHeight}px - 158px)` : ios ? `calc(${viewportHeight}px - 185px)` : `calc(${viewportHeight}px - 162px)`,
      height: isDesktop
    ? pin > 0
      ? `calc(${viewportHeight}px - 135px)`
      : `calc(${viewportHeight}px - 168px)`
    : `calc(${viewportHeight}px - 156px + env(safe-area-inset-bottom, 0px) + 8px)`,
      position: isDesktop ? 'relative' : "fixed",
      width: "100%"
    },
    "list": {
      marginTop: isDesktop ? "72px" : "124px",
      height: isDesktop ? "calc(100% - 158px)" : right ? "500px" : "calc(100% - 172px)",
      paddingBottom: isDesktop ? '' : ios ? `calc(env(safe-area-inset-bottom, 0px) + 90px)` : "93px",
      overflow: right ? 'hidden' : 'auto',
    },
    "unit": {
      marginTop: isDesktop ? "72px" : "69px",
      height: isDesktop ? "calc(100% - 72px)" : "calc(100% - 69px)",
    },
    "compare": {
      marginTop: isDesktop ? "200px" : "170px",
      height: isDesktop ? "calc(100% - 200px)" : "calc(100% - 119px)",
      overflow: "hidden"
    },
    "favorites": {
      marginTop: isDesktop ? "130px" : "131px",
      height: isDesktop ? "calc(100% - 130px)" : "calc(100% - 119px)",
    },
    "gallery": {
      marginTop: isDesktop ? "125px" : "125px",
      height: isDesktop ? "calc(100% - 125px)" : "calc(100% - 125px)"
    },
    "downloads": {
      marginTop: isDesktop ? "135px" : "119px",
      height: isDesktop ? "calc(100% - 135px)" : "calc(100% - 119px)"
    }
  }
  
  const rootStyle = {
    "isometry": {
      height: isDesktop ? '100%' : '125vh',
      overflowY: isDesktop ? "hidden" : 'auto'
    }
  }


  useEffect(() => {
    // Function to update the viewport height
    const updateViewportHeight = () => {
      setViewportHeight(window.innerHeight);
    };

    // Set the viewport height on load
    updateViewportHeight();

    // Add resize event listener
    window.addEventListener("resize", updateViewportHeight);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("resize", updateViewportHeight);
    };
  }, []);
  
  return (
    <Root styles={rootStyle[activeURL[activeURLindex]]}>
      { pin >= 0 && DrawersLeft.map(i => i) }
      { pin >= 0 && DrawersRight.map(i => i) }
      <Content left={left} right={right} nav={nav} styles={style[activeURL[activeURLindex]]}>
      {/* {here.includes('isometry')  && isDesktop && <WeatherMode />} */}
        { Views }
      </Content>
      <TopMenu left={left} right={right} nav={nav}/>
      <DualMenu left={left} right={right} nav={nav}/>
      { Navigation }
    </Root>
  )
}